import { TagGroupCreate, TagGroupEdit, TagGroupList } from 'pages/tag-groups';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'library_tag_groups',
  label: 'Grupos de tags da biblioteca',
  list: TagGroupList,
  create: TagGroupCreate,
  edit: TagGroupEdit,
  route: 'teaching_resources/libraries/:libraryId/tag-groups',
  actions: ['list', 'show', 'create', 'edit'],
  parentName: 'teaching_resources',
  hide: true
};

export default generateResources(resource);
